import { MaxString, ModelBase, Property, Required, ShortString, VeryLongString } from '@skylab-shared/core';
import { MailTemplateKind } from './mail-template-kind';

export class MailTemplateModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    @ShortString('data-model.mail-template.validation.name.length')
    @Required('data-model.mail-template.validation.name.non-empty')
    public name: string;

    @Property()
    public default: boolean;

    @Property()
    public kind: MailTemplateKind;

    @Property()
    @ShortString('data-model.mail-template.validation.sender-name.length')
    public senderName: string;

    @Property()
    @VeryLongString('data-model.mail-template.validation.subject-pattern.length')
    public subjectPattern: string;

    @Property()
    @MaxString('data-model.mail-template.validation.message-pattern.length')
    public messagePattern: string;
}
